import { DataSection03 } from "@/Component/Main/Section03New";
let data: DataSection03[] = [
  {
    id: 0,
    title: "디렉터팩 롱 다운 자켓 BLACK",
    price: 429000,
    imgUrl: "img/section03_product001_front.jpg",
    imgUrlSub: "img/section03_product001_back.jpg",
    alt: "디렉터팩 롱 다운 자켓 BLACK",
  },
  {
    id: 1,
    title: "로고 기모 후드 집업 M.GREY",
    price: 139000,
    imgUrl: "img/section03_product002_front.jpg",
    imgUrlSub: "img/section03_product002_back.jpg",
    alt: "로고 기모 후드 집업 M.GREY",
  },
  {
    id: 2,
    title: "로고 기모 후드 집업 BLACK",
    price: 139000,
    imgUrl: "img/section03_product003_front.jpg",
    imgUrlSub: "img/section03_product003_back.jpg",
    alt: "로고 기모 후드 집업 BLACK",
  },
  {
    id: 3,
    title: "로고 기모 후드 집업 우먼 M.GREY",
    price: 139000,
    imgUrl: "img/section03_product004_front.jpg",
    imgUrlSub: "img/section03_product004_back.jpg",
    alt: "로고 기모 후드 집업 우먼 M.GREY",
  },
];

export default data;
